import _ from 'lodash';
import deviceTypes from 'dictionaries/DeviceTypes';

export const getDeviceTypeList = () => {
  return _.map(deviceTypes, type => {
    return {
      title: type.title,
      value: type.id
    };
  });
};

export const getDeviceTitle = type => {
  if (_.has(deviceTypes, type)) {
    return deviceTypes[type].title;
  }

  return 'Wrong device type';
};

export const hasCBSDDPtype = type => Number(type) === deviceTypes[14].id;



// WEBPACK FOOTER //
// ./src/helpers/DeviceTypeHelper.js